import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
//import LandingPage from "./WebPages/ClientSide/LandingPage";
import LandingPage from "./WebPages/ClientSide/LandingPage";
import RegistrationPage from "./WebPages/ClientSide/Login/Registration";
import LoginPage from "./WebPages/ClientSide/Login/Login";
import ForgotPasswordPage from "./WebPages/ClientSide/Login/forgot_password";
import Sidebar from "./WebPages/ClientSide/ApplicationForm/sidebar";
import DashboardPage from "./WebPages/ClientSide/ApplicationForm/dashboard";
import AdminLogin from "./WebPages/AdminSide/login";
import AdminDashboard from "./WebPages/AdminSide/AdminDashboard";




function App() {
	return (
		<BrowserRouter basename="/ASTU_JMEE_JLEE">
			<Routes>
				<Route path="/" element={<LandingPage />} />
				<Route path="/Registration" element={<RegistrationPage />} />
				<Route path="/Login" element={<LoginPage />} />
				<Route path="/Forgot_Password" element={<ForgotPasswordPage />} />
				<Route path="/Sidebar" element={<Sidebar />} />
				<Route path="/Dashboard" element={<DashboardPage />} />
				
				
				<Route path="/AdminLogin" element={<AdminLogin />} />
				<Route path="/AdminDashboard" element={<AdminDashboard />}/>
			</Routes>
		</BrowserRouter>
	);
}


export default App;
